import React, { useState, useEffect } from 'react';
import { Grid, Typography, Box, Card, CardMedia, CardContent } from "@material-ui/core";
import { makeStyles } from '@material-ui/styles';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import IconButton from '@material-ui/core/IconButton';
import FooterBar from './../../component/FooterAtom/index'
import { useHistory, useLocation } from "react-router-dom";
import Drawer from '@material-ui/core/Drawer';
import MobileBrowserMarketDrawer from './../../pages/Mobile_Browser_Market1/Mobile_Browser_Market1'
import CircularIndeterminate from './../../component/Loader/index';
import NoFollowMeta from '../../component/NofollowMeta';

const Mobile_Browser1 = () => {
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();

    const [PhoneNo, setPhoneNo] = useState("");
    
 


    useEffect(() => {
        //    setLoginFlag(localStorage.getItem("loginFlag"));
        //    console.log(loginFlag);
    });

   

    const profile = () => {
        history.push("/profile");

    }

    const [state, setState] = React.useState({
        bottom: false,
    });

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    return (
        <Grid p={2} className={classes.commonSectionBuild}>
            <NoFollowMeta/>
            <Box className={classes.headerBrowser}>
                <Typography variant="h6" style={{ fontWeight: 600 }} >
                    सौदेबाज़ी
                </Typography>
                <Box mr={1} fullwidth>
                    <IconButton onClick={profile}>
                        <AccountCircleIcon fontSize="large" />
                    </IconButton>

                </Box>
            </Box>

            <Box className={classes.centerText}>
                <Typography>यहाँ पर कोई भी सौदा उपलब्ध नहीं है  </Typography>
            </Box>
            {/* </Box>
            <Box className={classes.kishanDetail}>
                <Box className={classes.textCenterSet}>
                <Box mb={1} className={classes.farmerImage}>
                        <Avatar className={classes.image} alt="farmer" src="https://media.istockphoto.com/photos/indian-farmer-at-onion-field-picture-id1092520698?s=612x612" />
                    </Box>
                    <Typography variant="body1">
                    अजय कुमार
                    </Typography>
                </Box>
                <Box className={classes.textCenterSet}>
                    <Box ml={1} className={classes.rotateSHareIcon}>
                        <GppGoodRoundedIcon />
                    </Box>
                    <Typography variant="body1">
                        निजी सौदा 
                    </Typography>
                </Box>
            </Box>
            <ProductItem />
            <Box p={2}>
                <Typography variant="body1" >
                    7 दिन का क्रेडिट उपलब्ध
                </Typography>
            </Box>
            <Box className={classes.contetnArrange}>
            <Box mr={1} fullwidth>
                {['bottom'].map((anchor) => (
                    <ButtonAtom
                        startIcon={<CallIcon />}
                        name="कॉल करे "
                        onClick={toggleDrawer(anchor, true)}
                    />
                ))}
                </Box>
                <Box ml={1} fullwidth>
                    {['bottom'].map((anchor) => (
                        <ButtonAtom
                            startIcon={<WhatsAppIcon />}
                            name="व्हाट्सप्प करे"
                            cclass="whatsUpBtn"
                            onClick={toggleDrawer(anchor, true)}
                        />
                    ))}
                </Box>
            </Box>
            <Box p={2}>
                <Typography variant="body1">
                    सभी आज रात 12 बजे तक है
                </Typography>
            </Box>
            <Box className={`${classes.contetnArrange} ${classes.manageIconCenter}`}>
                <KeyboardDoubleArrowDownIcon />
            </Box> */}
            <Box>
                <FooterBar />
            </Box>

            <div>
                {['bottom'].map((anchor) => (
                    <React.Fragment key={anchor}>
                        <Drawer className={classes.drawerDesign} anchor={anchor} open={state[anchor]} onClose={toggleDrawer(anchor, false)}>
                            <MobileBrowserMarketDrawer />
                        </Drawer>
                    </React.Fragment>
                ))}
            </div>

        </Grid>
    )
};

const useStyles = makeStyles(() => ({
    drawerDesign: {
        '& .MuiDrawer-paper': {
            paddingTop: 19,
            borderRadius: '20px 20px 0 0',
        }
    },
    headerBrowser: {
        background: '#53252f',
        color: '#fff',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',
    },
    kishanDetail: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',
    },
    textCenterSet: {
        display: 'flex',
        alignItems: 'center',
    },
    rotateSHareIcon: {
        transform: 'rotateY(360deg)',
    },
    contetnArrange: {
        width: '100%',
        padding: '10px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        '& div': {
            width: '100%'
        }
    },
    commonSectionBuild: {
        maxWidth: 540,
        float: 'none',
        margin: '0 auto'
    },
    manageIconCenter: {
        justifyContent: 'center',
        padding: '50px 0 20px',
        boxSizing: 'border-box',
    },
    farmerImage: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        size: '100%',
    },
    image: {
        width: '150px',
        height: '150px',
        borderRadius: '50%',
        position: 'relative',
        overflow: 'hidden',
    },
    centerText:{
        
        marginTop: '50px',
        textAlign: 'center',
        paddingTop:'100px'
    }
}));
export default Mobile_Browser1;
